// @flow
import UserManagementAPI from '../services/UserManagementAPI';
import type { Dispatch, GetState } from '../../../types/Store';
import type { Role } from '../../../types/Data';
import RadioUser from '../../../domain/RadioUser';
import { getToken, getStation } from '../../authentication/session/reducers/sessionReducer';

export const FETCH_PERMITTED_ROLES = 'UserManagementActions/FETCH_PERMITTED_ROLES';
export const FETCH_PERMITTED_ROLES_SUCCESS = 'UserManagementActions/FETCH_PERMITTED_ROLES_SUCCESS';
export const FETCH_PERMITTED_ROLES_ERROR = 'UserManagementActions/FETCH_PERMITTED_ROLES_ERROR';

export const FETCH_ALL_USERS = 'UserManagementActions/FETCH_ALL_USERS';
export const FETCH_ALL_USERS_SUCCESS = 'UserManagementActions/FETCH_ALL_USERS_SUCCESS';
export const FETCH_ALL_USERS_ERROR = 'UserManagementActions/FETCH_ALL_USERS_ERROR';

export const INVITE_USER = 'UserManagementActions/INVITE_USER';
export const INVITE_USER_SUCCESS = 'UserManagementActions/INVITE_USER_SUCCESS';
export const INVITE_USER_ERROR = 'UserManagementActions/INVITE_USER_ERROR';

export const UPDATE_USER_ROLES = 'UserManagementActions/UPDATE_USER_ROLES';
export const UPDATE_USER_ROLES_SUCCESS = 'UserManagementActions/UPDATE_USER_ROLES_SUCCESS';
export const UPDATE_USER_ROLES_ERROR = 'UserManagementActions/UPDATE_USER_ROLES_ERROR';

export const DELETE_USER = 'UserManagementActions/DELETE_USER';
export const DELETE_USER_SUCCESS = 'UserManagementActions/DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'UserManagementActions/DELETE_USER_ERROR';

export const fetchPermittedRoles = () => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: FETCH_PERMITTED_ROLES });

    const callSign = getStation(getState());
    const token = getToken(getState());

    try {
      const roles = await UserManagementAPI.fetchPermittedRoles(callSign, token);
      dispatch({ type: FETCH_PERMITTED_ROLES_SUCCESS, roles: roles });
    } catch (error) {
      dispatch({ type: FETCH_PERMITTED_ROLES_ERROR });
    }
  };
};

export const fetchUsers = () => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: FETCH_ALL_USERS });

    const callSign = getStation(getState());
    const token = getToken(getState());

    try {
      const users = await UserManagementAPI.fetchUsersForStation(callSign, token);

      const assembledUsers = users.map(user => RadioUser.parse(user));

      dispatch({ type: FETCH_ALL_USERS_SUCCESS, users: assembledUsers });
    } catch (error) {
      dispatch({ type: FETCH_ALL_USERS_ERROR });
    }
  };
};

export const inviteUser = (user: RadioUser) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: INVITE_USER });

    const callSign = getStation(getState());
    const token = getToken(getState());

    try {
      await UserManagementAPI.inviteUser(callSign, token, user);
      dispatch({ type: INVITE_USER_SUCCESS, user: user });
    } catch (error) {
      dispatch({ type: INVITE_USER_ERROR });
    }
  };
};

export const updateUserRoles = (user: RadioUser, roles: Array<Role>) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: UPDATE_USER_ROLES });

    const callSign = getStation(getState());
    const token = getToken(getState());

    try {
      await UserManagementAPI.updateUserRoles(callSign, token, user, roles);
      dispatch({ type: UPDATE_USER_ROLES_SUCCESS, user: user, roles: roles });
    } catch (error) {
      dispatch({ type: UPDATE_USER_ROLES_ERROR });
    }
  };
};

export const deleteUser = (user: RadioUser) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: DELETE_USER });

    const callSign = getStation(getState());
    const token = getToken(getState());

    try {
      await UserManagementAPI.deleteUser(callSign, token, user);
      dispatch({ type: DELETE_USER_SUCCESS, user: user });
    } catch (error) {
      dispatch({ type: DELETE_USER_ERROR });
    }
  };
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/userManagement/actions/userManagementActions.js